// Include jQuery plugins
//require('jquery.sample');

// Import non-jQuery modules
//const sample = require('sample');

// Define wp_localize_script handles
/* */

(function($) {
    const wntrTheme = {
        body: $('body'),
        html: $('html'),
        window: $(window),
        document: $(document),
        current_position: 0,

        /**
         * Initialise theme JS on page load
         */
        init: function() {
            // Do we have JS?
            $('html').removeClass('no-js');

            // Automatically call all methods that start with __, in the order they're defined
            for(const prop in wntrTheme) {
                if(prop.startsWith('__') && typeof wntrTheme[prop] === 'function') {
                    wntrTheme[prop].call();
                }
            }
        },
        __scrollToAnchor: function() {
            wntrTheme.body.find('a').on('click', function(e) {
                const link_url = $(this).attr('href');
                if(link_url.indexOf('#') > -1) {
                    e.preventDefault();
                    const id = link_url.substring(link_url.indexOf('#') + 1);
                    if(wntrTheme.body.find('#' + id).length > 0) {
                        document.querySelectorAll('#' + id)[0].scrollIntoView({ behavior: 'smooth' });
                    } else {
                        window.location.href = link_url;
                    }
                }
            });
        },
        __responsiveVideo: function() {
            const iframe = wntrTheme.body.find('iframe[allowfullscreen="allowfullscreen"]');
            if(iframe.length > 0) {
                iframe.wrap("<div class='embed-container'></div>");
            }
        },
        __fancyBoxSettings: function() {
            wntrTheme.body.find('[data-fancybox]').fancybox({
                animationEffect: 'fade',
                touch: false
                // modal: true,
                // touch: {
                //   vertical: false, // Allow to drag content vertically
                //   momentum: false // Continue movement after releasing mouse/touch when panning
                // },
                // hideScrollbar: false,
            });
        },
        __hideControlsOnSafari: function() {
            const userAgent = window.navigator.userAgent;

            if(userAgent.match(/iPad/i) || userAgent.match(/iPhone/i)) {
                const video = wntrTheme.body.find('#header-movie');
                if(video.length > 0) {
                    video.hide();
                }
            }
        },
        __onPlayerReady: function() {
            const vid = document.getElementById('header-movie');

            if(vid) {
                vid.onloadeddata = function() {
                    //wntrTheme.body.find('.image-carousel-title-wrapper').fadeIn(600);
                    //why this? Well, if you want to overlay text on top of your video, you
                    //will have to fade it in once your video has loaded in order for this
                    //to work in Safari, or your will get an origin error.
                    setTimeout(function() {
                        vid.play();
                    }, 300);
                };
            }
        },
        /**
         * Dropdown / submenu handler
         */
        __submenuHandler: () => {
            const dropdownToggle = wntrTheme.body.find('.menu-item-has-children');

            if(!dropdownToggle.length) {
                return false;
            }

            const submenu = wntrTheme.body.find('.sub-menu');

            // desktop
            if($(window).width() > 1024) {

                // open menu on tabbing
                wntrTheme.body.find('.menu-item-has-children a').on('focus', function() {
                    $(this).parent('.menu-item-has-children').find('.sub-menu').addClass('is-active');
                });

                // close menu on 'body' click, but not inside of submenu
                wntrTheme.body.on('mousedown', function(e) {
                    if(!$(e.target).closest('.sub-menu').length && submenu.hasClass('is-active')) {
                        submenu.removeClass('is-active');
                    }
                });

                // close menu on press esc
                wntrTheme.body.on('keydown', function(e) {
                    if(e.key === "Escape" && submenu.hasClass('is-active')) {
                        submenu.removeClass('is-active');
                    }
                });

                // close menu after tabbing last link
                submenu.find('li:last-of-type > a').on('keydown', function(e) {
                    if(e.shiftKey && e.keyCode === 9) {
                        submenu.addClass('is-active');
                    } else if(e.keyCode === 9) {
                        submenu.removeClass('is-active');
                    }
                });

                // close on mouse out
                submenu.on('mouseout', function() {
                    submenu.removeClass('is-active');
                });

                // open current menu on mouse in
                dropdownToggle.on('mouseover', function() {
                    $(this).find('.sub-menu').addClass('is-active');
                });

                // open current menu on mouse in
                dropdownToggle.on('mouseout', function() {
                    $(this).find('.sub-menu').removeClass('is-active');
                });

            } else {
                dropdownToggle.on('click', function() {
                    $(this).find('.toggle-sub-menu').toggleClass('is-active');
                    $(this).find('.sub-menu').slideToggle(150);
                });

            }
        },
        __toggleCalendar: function() {
            wntrTheme.body.find('.toggle-news-calendar').on('click', function() {
                const el = $(this);
                el.find('span').toggleClass('hidden');
                wntrTheme.body.find('.news-event-wrapper').toggleClass('hidden');
            });
        },
        __doMatchHeight: function() {
            if(wntrTheme.body.find('.contact-content').length > 0) {
                wntrTheme.body.find('.contact-content').matchHeight();
            }

            if(wntrTheme.body.find('.politic').length > 0) {
                wntrTheme.body.find('.politic').matchHeight();
            }

            if(wntrTheme.body.find('.info-grid-6').length > 0) {
                wntrTheme.body.find('.info-grid-6').matchHeight();
            }

            if(wntrTheme.body.find('.info-grid-6 h3').length > 0) {
                wntrTheme.body.find('.info-grid-6 h3').matchHeight();
            }

            if(wntrTheme.body.find('.info-grid-8-inner').length > 0) {
                wntrTheme.body.find('.info-grid-8-inner').matchHeight();
            }

            if(wntrTheme.body.find('.info-grid-8 h3').length > 0) {
                wntrTheme.body.find('.info-grid-8 h3').matchHeight();
            }

            if(wntrTheme.body.find('.news-title').length > 0) {
                wntrTheme.body.find('.news-title').matchHeight();
            }

            if(wntrTheme.body.find('.page-section-debate'.length > 0 || $(window).outerWith > 1024)) {
                if(wntrTheme.body.find('.debate-meta').length > 0) {
                    wntrTheme.body.find('.debate-meta').matchHeight();
                }

                if(wntrTheme.body.find('.debate').length > 0) {
                    wntrTheme.body.find('.debate').matchHeight();
                }

                if(wntrTheme.body.find('.debate-content').length > 0) {
                    wntrTheme.body.find('.debate-content').matchHeight();
                }
            }

            if(wntrTheme.body.find('.search-result-inner').length > 0) {
                wntrTheme.body.find('.search-result-inner').matchHeight();
            }

            if(wntrTheme.body.find('.politic h2').length > 0) {
                wntrTheme.body.find('.politic h2').matchHeight();
            }

            if(wntrTheme.body.find('.politic p').length > 0) {
                wntrTheme.body.find('.politic p').matchHeight();
            }

            if(wntrTheme.body.find('.politician').length > 0) {
                wntrTheme.body.find('.politician').matchHeight();
            }
        },
        __toggleMobileMenu: function() {
            wntrTheme.body.find('.header-toggle-menu').on('click', function() {
                const el = $(this);
                el.toggleClass('is-active');

                // The menu is open
                if(el.hasClass('is-active')) {
                    // Save current position from top
                    wntrTheme.current_position = wntrTheme.document.scrollTop();
                    wntrTheme.body.find('header').toggleClass('show-mobile-menu');
                    // SetTimeout till the css animation has ended
                    wntrTheme.html.toggleClass('html-fixed');
                } else {
                    wntrTheme.body.find('header').toggleClass('show-mobile-menu');
                    wntrTheme.html.toggleClass('html-fixed');
                    wntrTheme.document.scrollTop(wntrTheme.current_position);
                }
            });
        },
        __toggleHeaderSearch: function() {
            wntrTheme.body.find('.header-search-button').on('click', function() {
                wntrTheme.body.find('.header-search-form').toggleClass('show-header-search-form');

                wntrTheme.body.find('.header-search-form').one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function() {
                    wntrTheme.body.find('.header-search-input').focus();
                });
            });

            wntrTheme.body.find('.header-close-search').on('click', function() {
                wntrTheme.body.find('.header-search-form').toggleClass('show-header-search-form');
            });

            wntrTheme.body.find('.search-form-component').on('submit', function() {
                const el = $(this);
                el.find('.icon-search').hide();
                el.find('.icon-spinner').show();
            });
        },
        __closeHeaderSearch: function() {
            const serch_form = wntrTheme.body.find('.header-search-form');
            $(document).keyup(function(e) {
                if(e.keyCode === 27 && serch_form.hasClass('show-header-search-form')) {
                    serch_form.removeClass('show-header-search-form');
                }
            });
        },
        __initSlider: function() {
            if(wntrTheme.body.find('.page-section-image-carousel').length > 0) {
                const image_carousel_slider = wntrTheme.body.find('.image-carousel-wrapper'),
                    image_carousel_slider_content = wntrTheme.body.find('.page-section-image-carousel');

                image_carousel_slider.slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    autoplay: true,
                    autoplaySpeed: 4000,
                    speed: 1200,
                    pauseOnHover: false
                });

                image_carousel_slider.on('beforeChange', function() {
                    image_carousel_slider_content.addClass('hide-title');
                });

                image_carousel_slider.on('afterChange', function() {
                    image_carousel_slider_content.removeClass('hide-title');
                });
            }

            if(wntrTheme.body.find('.page-section-debate-news-preview').length > 0 && $(window).width() < 1024) {
                const settings = {
                    dots: true,
                    arrows: false,
                    infinite: true,
                    speed: 300,
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    adaptiveHeight: true,
                    responsive: [
                        {
                            breakpoint: 1300,
                            settings: "unslick"
                        },
                        {
                            breakpoint: 1024,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 1,
                                dots: true,
                                infinite: true,
                                adaptiveHeight: true,
                                arrows: false,
                            }
                        },
                        {
                            breakpoint: 720,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1,
                                dots: true,
                                infinite: true,
                                adaptiveHeight: true,
                                arrows: false,
                            }
                        }
                    ]
                };

                const debate = wntrTheme.body.find('.debate-news-preview__debate-wrapper');
                const news = wntrTheme.body.find('.debate-news-preview__news-wrapper');

                if(debate.length > 0) {
                    debate.slick(settings);
                }

                if(news.length > 0) {
                    news.slick(settings);
                }
            }

            if(wntrTheme.body.find('.page-section-facebook').length > 0) {
                wntrTheme.body.find('.facebook-posts').slick({
                    dots: true,
                    infinite: true,
                    speed: 300,
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    adaptiveHeight: true,
                    responsive: [
                        {
                            breakpoint: 1024,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 2,
                                infinite: true,
                                dots: true,
                                adaptiveHeight: true
                            }
                        },
                        {
                            breakpoint: 700,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1,
                                dots: true,
                                infinite: true,
                                adaptiveHeight: true
                            }
                        }
                    ]
                });
            }
        },
    };

    $(document).ready(wntrTheme.init);
})(jQuery);